import { IonBadge, IonRow } from '@ionic/react';
import { TeamUserCourseSummary } from '../../types/teamUserSummary';

interface CourseTableProps {
  courses: TeamUserCourseSummary[];
}

export function CourseTable({ courses }: CourseTableProps) {
  const formatDate = (dateString: string) => {
    if (!dateString || dateString.trim() === '') {
      return 'No activity';
    }
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return 'No activity';
    }
    return date.toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };

  return (
    <div className="rounded-b-lg shadow overflow-hidden border-t-0">
      <div className="overflow-x-auto">
        <div className="min-w-[600px]">
          {/* Table Header */}
          <IonRow className="bg-gray-50 border-b border-gray-200 flex">
            <div className="flex-1 basis-0 min-w-0 py-3 px-6">
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">Course Name</span>
            </div>
            <div className="flex-1 flex-shrink-0 min-w-0 py-3 px-6 text-center">
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">Progress</span>
            </div>
            <div className="flex-1 basis-0 min-w-0 py-3 px-6 text-right">
              <span className="text-xs font-medium text-gray-500 uppercase tracking-wider">Last Accessed</span>
            </div>
          </IonRow>

          {/* Table Body */}
          {courses.map((course, index) => (
            <IonRow
              key={course.id || `course-${index}`}
              className={`border-b border-gray-200 hover:bg-gray-50 transition-colors flex
                ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
            >
              <div className="flex-1 basis-0 min-w-[200px] py-3 px-4">
                <span className="font-semibold text-[#231F20] text-base block" title={course.name}>
                  {course.name}
                  {course.isCompleted && <span className="ml-2 text-green-600">✓</span>}
                </span>
              </div>
              <div className="flex-1 basis-0 min-w-[100px] py-3 px-4 text-center">
                <IonBadge color="primary" className="px-3 py-1.5 text-sm font-semibold">
                  {course.progress}%
                </IonBadge>
              </div>
              <div className="flex-1 basis-0 min-w-[150px] py-3 px-4 text-right">
                <span className="text-gray-600 text-sm whitespace-nowrap">
                  {formatDate(course.lastAccessed)}
                </span>
              </div>
            </IonRow>
          ))}
        </div>
      </div>
    </div>
  );
}
